/** @forge-header
 * @id          sportsStreamFormat
 * @role        Totals line formatter | sportsbook-style display (210.5 → "210.5")
 * @pattern     pure-fn
 * @purity      none
 * @units       n/a
 * @upstream    none
 * @downstream  SportsTable | useSportsStream
 * @exports     formatTotalLineValue:fn
 * @test        untested
 */
export function formatTotalLineValue(line: number | null | undefined): string {
  if (!Number.isFinite(line)) return '—';
  const numeric = line as number;
  return Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(1);
}
